<template>
  <div :class="`agregateClient ${css}`" v-if="show">
    <label>
      Usuário
    </label>

    <select>
      <option value>Selecione uma opção</option>
      <option v-for="(client, i) in agregateClients" :key="'ag' + i" :value="client.id" @click="update(client)">
        {{ client.nome }}
      </option>
    </select>
    <!--  <AutoComplete :list="agregateClients" @value="update(item)" :name="'nome'" /> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
//import AutoComplete from "@/components/AutoComplete";

export default {
  name: "AgregateClient",
  props: {
    client: Number,
    css: String,
  },
  components: {},
  data() {
    return {
      show: false,
      agregateClients: [],
    };
  },

  methods: {
    ...mapActions("admin", ["AGGREGATE_LIST"]),

    update(item) {
      this.$emit("value", item);
    },
  },
  beforeMount() {
    this.AGGREGATE_LIST({ id_cliente: this.client }).then(({ data }) => {
      this.agregateClients = data || [];
      if (data && data.length) this.show = true;
    });
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
</style>
